// Étape 7 (2026-11-02) : messages des codes renvoyés par le serveur (Shared/Constants/ApiMessage.cs).
// Les traductions déjà présentes dans les autres fichiers l'emportent.
const serverEnMessages = {
  AgentNotAttachedToStation: "You are not assigned to the station of this ticket.",
  ALocationWithCurrentStationAlreadyExist: "A location already exists for this station.",
  AccountEmailDoesNotExist: "No account exists with this email address.",
  ActualDateTimeIsRequiredForThisStatus: "The actual date and time are required for this status.",
  AdvertisingDetailCityIsRequired: "The city is required.",
  AdvertisingDetailContentUrlIsRequired: "The content URL is required.",
  AdvertisingDetailCountryIsRequired: "The country is required.",
  AdvertisingDetailEndDateIsRequired: "The end date is required.",
  AdvertisingDetailItemIsRequired: "At least one advertising item is required.",
  AdvertisingDetailRegionIsRequired: "The region is required.",
  AdvertisingDetailStartDateIsRequired: "The start date is required.",
  AdvertisingDetailTypeIsInvalid: "The advertising item type is invalid.",
  AdvertisingDetailVideoIdIsRequired: "The video is required.",
  AdvertisingDetailVideoPlayerTypeIsInvalid: "The video player type is invalid.",
  AdvertisingDetailVideoPlayerTypeIsRequired: "The video player type is required.",
  AdvertisingScreenIsInvalid: "The advertising screen is invalid.",
  AdvertisingTitleIsRequired: "The advertising title is required.",
  AdvertisingTypeIsInvalid: "The advertising type is invalid.",
  AmountToRefundInvalid: "The refund amount is invalid.",
  AuthenticatorAlreadyEnrolled: "An authenticator app is already set up for this account.",
  AuthenticatorNotEnrolled: "No authenticator app is set up for this account.",
  BaggageTariffDoesNotExist: "This baggage fare does not exist.",
  BaggageTariffIsChanged: "The baggage fare has changed. Please check the new amount.",
  BaseTariffParameterAlreadyUsedForSomeCompanyTariffParameters: "This base fare parameter is used by some company fare parameters.",
  BaseTariffParameterCategoryAlreadyUsedForSomeCompanyTariffParameters: "This base fare parameter category is used by some company fare parameters.",
  BaseTariffParameterIsRequired: "The base fare parameter is required.",
  BaseTripIdIsRequired: "The base trip is required.",
  BlobContainerDoesNotExist: "The file storage location does not exist.",
  BookingArrivalDateTimeIsInvalid: "The arrival date and time are invalid.",
  BookingDepartureDateTimeIsInvalid: "The departure date and time are invalid.",
  BookingDiscountVoucherNoMoreAvailable: "This discount voucher is no longer available.",
  BookingIdAlreadyExist: "This booking already exists.",
  BookingIdIsRequired: "The booking is required.",
  BookingPassengersNotSet: "The passengers have not been entered for this booking.",
  BookingSegmentDoseNotExist: "The booking segment does not exist.",
  BookingSessionIsInvalidOrExpired: "The booking session is invalid or has expired.",
  BookingTicketDoesNotExist: "This ticket does not exist.",
  BookingTicketIdRequired: "The ticket is required.",
  BookingTicketsIsRequired: "Tickets are required.",
  BookingTripIdIsRequired: "The trip is required.",
  BookingUserIdIsRequired: "The booking user is required.",
  BookingUserNameIsRequired: "The booking user name is required.",
  BoxCategoryIsAlreadyExist: "This parcel category already exists.",
  BoxCategoryIsRequired: "The parcel category is required.",
  BoxCategoryIsUsingForSomeShipmentTariffs: "This parcel category is used by some parcel fares.",
  BoxCategoryNameIsRequired: "The parcel category name is required.",
  BoxDescriptionIsRequired: "The parcel description is required.",
  BoxInsuranceAmountIsInvalid: "The parcel insurance amount is invalid.",
  BoxInsuranceTariffIsChanged: "The parcel insurance rate has changed. Please check the new amount.",
  BoxQuantityIsInValid: "The parcel quantity is invalid.",
  BoxTariffAmountIsInvalid: "The parcel fare amount is invalid.",
  BoxTariffIsChanged: "The parcel fare has changed. Please check the new amount.",
  BoxTypeIsAlreadyExist: "This parcel type already exists.",
  BoxTypeIsRequired: "The parcel type is required.",
  BoxTypeIsUsingForSomeBoxCategories: "This parcel type is used by some parcel categories.",
  BoxVolumeIsAlreadyExist: "This volume already exists.",
  BoxVolumeIsRequired: "The volume is required.",
  BoxVolumeIsUsingForSomeShipmentTariffs: "This volume is used by some parcel fares.",
  BoxVolumeNameIsRequired: "The volume name is required.",
  BoxVolumeValueIsInvalid: "The volume value is invalid.",
  BoxWeightIsAlreadyExist: "This parcel weight range already exists.",
  BoxWeightIsRequired: "The weight range is required.",
  BoxWeightIsUsingForSomeShipmentTariffs: "This weight range is used by some parcel fares.",
  BoxWeightNameIsRequired: "The weight range name is required.",
  BusBrandIsAlreadyUsedForSomeBuses: "This bus brand is used by some buses.",
  BusDoesNotExist: "This bus does not exist.",
  BusInsurancePolicyNumberAlreadyExist: "This insurance policy number already exists.",
  BusInsurerIsAlreadyUsedForSomeBusInsurance: "This insurer is used by some bus insurance policies.",
  BusModelIsAlreadyUsedForSomeBuses: "This bus model is used by some buses.",
  BusStationPairAlreadyExist: "This bus is already assigned to a station for this period.",
  CanNotCancelShipmentAlreadyDeparted: "This shipment cannot be cancelled because it has already departed.",
  CanNotGetStationOfCurrentRegister: "The station of the current register could not be found.",
  CanNotModifyNonConflictedSeat: "Only seats in conflict can be changed.",
  CancellationPolicyPlanIsRequired: "The cancellation policy schedule is required.",
  CancellationRequestAlreadyPending: "A cancellation request is already pending.",
  CancellationRequestDoesNotExist: "This cancellation request does not exist.",
  CancellationRequestIsNotApproved: "This cancellation request has not been approved.",
  CancellationRequestIsNotPending: "This cancellation request is no longer pending.",
  CancellationTicketConditionIsRequired: "The ticket condition is required for the cancellation policy.",
  CannotCancelTheTripAlreadyGone: "The ticket cannot be cancelled because the trip has already departed.",
  CannotCancelTicketHasConflictedTrip: "This ticket cannot be cancelled because it has a trip in conflict.",
  CannotChangeSeatingModelThatAlreadyUsedForSomeBookings: "The seating layout cannot be changed because it is already used by some bookings.",
  CashChangeIsInvalid: "The change amount is invalid.",
  CashTenderAndCashChangeIsNotEqualTicketChaneFee: "The amount received minus the change does not match the ticket change fee.",
  CashTenderAndCashChangeIsNotEqualTotalAmount: "The amount received minus the change does not match the total amount.",
  CashTenderCanNotLessThanTotalAmount: "The amount received cannot be less than the total amount.",
  CashTenderIsInvalid: "The amount received is invalid.",
  CashTenderOrCashChangeIsInvalid: "The amount received or the change is invalid.",
  CashierDoesNotExist: "This cashier does not exist.",
  ChangeAmountCannotGreaterThanBoxTotalAmount: "The changed amount cannot exceed the parcel total.",
  ChangeAmountNoteIsRequired: "A note is required when changing the amount.",
  ChangePasswordSuccessful: "Your password has been changed.",
  CheckInTicketDoesNotExist: "This ticket does not exist.",
  ChildMustTravelWithAdult: "A child or infant must travel with an adult from the same booking. Modify the linked tickets together.",
  CityCodeAlreadyExist: "This city code already exists.",
  CityNameAlreadyExist: "This city name already exists.",
  CompanyAccountIsAlreadyExist: "An account with this payment partner already exists for the company.",
  CompanyDashboardReportDateIsRequired: "The date is required.",
  CompanyDashboardReportYearIsRequired: "The year is required.",
  CompanySmsServiceUrlCountryDuplicated: "An SMS service is already configured for this country.",
  CompanySubscribeNotFound: "The company subscription was not found.",
  CompanyTicketIsAlreadyExist: "This ticket class already exists for the company.",
  ConfirmEmailLinkIsInvalidOrExpired: "The email confirmation link is invalid or has expired.",
  ConfirmationBookingNotificationTypeIsInvalid: "The booking confirmation notification type is invalid.",
  ConflictByAssignBusWithDifferentSeatingModel: "A bus with a different seating layout has been assigned to the trip.",
  ConflictByTripStationIsRemoved: "A station has been removed from the trip.",
  ControlRecordAfterArrival: "Action recorded after the trip arrived: refused.",
  ControlRecordCounterReused: "Counter already used by this certificate: record refused.",
  ControlRecordInvalid: "Control record unreadable or signature invalid.",
  ControlRecordTooMany: "Too many records in this batch.",
  CouldNotGetCompanyInfoForThisBooking: "The company information for this booking could not be found.",
  CountryCodeAlreadyExist: "This country code already exists.",
  CreateBookingPaymentMethodIsRequired: "The payment method is required.",
  CreateBookingSessionIsRunning: "A booking is already being created. Please wait.",
  CreateNewRoleUnsuccessful: "The role could not be created.",
  CreateUserAccountUnsuccessful: "The user account could not be created.",
  CreditNoteAmountInvalid: "The credit note amount is invalid. It must not exceed the balance or the sale total.",
  CreditNoteCancelled: "This credit note has been cancelled.",
  CreditNoteChangedMeanwhile: "This credit note was used by another sale in the meantime. Please check the new balance and confirm again.",
  CreditNoteExpired: "This credit note has expired.",
  CreditNoteHolderNotConfirmed: "Please confirm the credit note holder's name.",
  CreditNoteLookupCriteriaMissing: "Enter the credit note number or the holder's phone number.",
  CreditNoteNotAllowedHere: "A credit note cannot be used for this sale.",
  CreditNoteNotFound: "This credit note was not found.",
  CreditNotePhoneMismatch: "The phone number does not match this credit note.",
  CreditNoteUsedUp: "This credit note has already been fully used.",
  CurrentShipmentBoxStatusDoesNotAllowToDoShipmentLoading: "This parcel cannot be loaded in its current status.",
  CurrentShipmentBoxStatusDoesNotAllowToDoShipmentOffload: "This parcel cannot be unloaded in its current status.",
  CurrentTicketConditionIsNotAllowToModify: "The current ticket condition does not allow changes.",
  CurrentTicketStatusIsNotAllowToDoCheckin: "This ticket cannot be checked in in its current status.",
  CurrentTripStatusIsNotAllowToBookFromThisStation: "The current trip status does not allow booking from this station.",
  CurrentWalletBalanceIsLessThanTotalAdditionalAmount: "The wallet balance is less than the additional amount due.",
  CurrentWalletBalanceIsLessThanTotalBookingAmount: "The wallet balance is less than the booking total.",
  DateOfBirthIsRequired: "The date of birth is required.",
  DepartureDateTimeCanNotLessThanCurrentCityLocalDateTime: "The departure date and time cannot be earlier than the current local time in the city.",
  DepartureDateTimeCanNotLessThanCurrentStationLocalDateTime: "The departure date and time cannot be earlier than the current local time at the station.",
  DepartureSeatIsRequired: "The outbound seat is required.",
  DepartureStationDoesNotExistOrHasBeenDeleted: "The departure station does not exist or has been deleted.",
  DepartureTicketConditionIsRequiredForModification: "The outbound ticket condition is required for the change.",
  DepartureTripAndSeatAreSameAsCurrentTrip: "The outbound trip and seat are the same as the current ones.",
  DepartureTripCompanyIdIsRequired: "The outbound trip company is required.",
  DepartureTripStatusIsNotValidToModify: "The outbound trip status does not allow changes.",
  DestinationCityDoesNotHaveAnyStation: "The destination city has no station.",
  DestinationIdIsRequired: "The destination station is required.",
  DestinationNameIsRequired: "The destination station name is required.",
  DestinationStationIsNotBelongToSelectedTrip: "The destination station is not on the selected trip.",
  DeviceAttestationChallengeInvalid: "The device verification failed. Please try again.",
  DeviceNotRegistered: "This device is not registered.",
  DevicePublicKeyInvalid: "The device key is invalid.",
  DeviceScopeNotAllowed: "You are not allowed to use this device.",
  DeviceScopeNotSupported: "This device is not assigned to a station.",
  DiscountNameAlreadyExist: "This discount name already exists.",
  EmailAddressIsRequiredForSendTicketReceiptByEmail: "An email address is required to send the receipt by email.",
  EmailTemplateAlreadyExist: "An e-mail template with this name already exists.",
  EmailTemplateDoesNotExist: "This email template does not exist.",
  EmployeeCodeAlreadyExist: "This employee code already exists.",
  EmployeeCodeRequired: "The employee code is required.",
  EmployeePaymentMethodBankPortionInvalid: "The cash, bank and mobile money shares must add up to 100%.",
  EmployeeUniqueIdAlreadyExist: "This employee unique number already exists.",
  EmployeeUniqueIdRequired: "The employee unique number is required.",
  FileImportInvalidColumnCount: "The import file has an invalid number of columns.",
  FileImportInvalidColumnName: "The import file has an invalid column name.",
  FileImportNotFound: "The import file was not found.",
  FirstNameIsRequired: "The first name is required.",
  FollowUpCommentIsRequired: "The follow-up comment is required.",
  FollowUpDateTimeIsRequired: "The follow-up date and time are required.",
  FollowUpTypeIsInvalid: "The follow-up type is invalid.",
  FollowUpUserIdIsRequired: "The user is required.",
  GenderIsInvalid: "The gender is invalid.",
  HasExceptionDuringBlockSeats: "An error occurred while blocking the seats.",
  IdentityCountryCodeIsRequired: "The identity document country is required.",
  IdentityDocumentNumberIsRequired: "The identity document number is required.",
  InsufficientBalance: "The balance is insufficient.",
  InvalidIdentifier: "A required identifier is missing or empty.",
  InvalidTwoFactorCode: "The verification code is invalid.",
  JourneyTypeIsInvalid: "The journey type is invalid.",
  LastNameIsRequired: "The last name is required.",
  LianeBookingDoesNotExist: "This booking does not exist.",
  LianeUserEmailAddressIsRequired: "The email address is required.",
  LianeUserEmailAlreadyExist: "This email address is already in use.",
  LianeUserEmailOrPhoneNumberIsRequiredForForgotPassword: "Enter your email address or phone number to reset your password.",
  LianeUserIsNotActive: "This account is not active.",
  LianeUserLoginMethodIsNotAvailable: "This sign-in method is not available.",
  LianeUserOtpIsInvalid: "The verification code is invalid.",
  LianeUserPasswordIsRequired: "The password is required.",
  LianeUserPhoneNumberAlreadyExist: "This phone number is already in use.",
  LianeUserRefreshTokenInvalidOrExpired: "Your session has expired. Please sign in again.",
  LianeUserWalletIsBlocked: "This wallet is blocked.",
  LocationIsUsingForSomeTrips: "This location is used by some trips.",
  LocationLatitudeIsRequired: "The latitude is required.",
  LocationLongitudeIsRequired: "The longitude is required.",
  LocationPlaceIdAlreadyExist: "This place already exists.",
  MainPassengerIsNotSelected: "The main passenger is not selected.",
  ManualEntryReasonRequired: "Choose why the QR code is unreadable.",
  ModifySeatsAreRequired: "The seats to change are required.",
  ModifyTicketsAreRequired: "The tickets to change are required.",
  ModifyingDepartureTripDoesNotExist: "The new outbound trip does not exist.",
  ModifyingReturnTripDoesNotExist: "The new return trip does not exist.",
  MultipleCurrentUserTravellingAreSelected: "Only one passenger can be marked as yourself.",
  NewStatusIsNotValid: "The new status is not valid.",
  NextFollowUpDateTimeIsRequired: "The next follow-up date and time are required.",
  NextStopNotFound: "The next stop was not found.",
  NoBaggageSellingFoundFromLastReconciliation: "No baggage sales since the last reconciliation.",
  NoBookingFoundFromLastReconciliation: "No booking was found since the last reconciliation.",
  NoBusIsAssigned: "No bus is assigned to this trip.",
  NoCompanyHasAssignedToTheCurrentGlobalCashier: "No company is assigned to this global cashier.",
  NoDriverOrCoDriverIsAssigned: "No driver or co-driver is assigned to this trip.",
  NoOfBagMotoIsInvalid: "The number of motorcycles is invalid.",
  NoOfSpecialBagIsInvalid: "The number of special bags is invalid.",
  NoOfStandardBagIsInvalid: "The number of standard bags is invalid.",
  NoShipmentTariffAvailable: "No parcel fare is available.",
  NoTripAvailable: "No trip is available.",
  NotificationAccountIsAlreadyExist: "This notification account already exists.",
  NotificationIsAlreadyExist: "This notification already exists.",
  NotificationSMSIsNotEnbaled: "SMS notification is not enabled.",
  OfflineTicketInvalid: "Invalid offline ticket.",
  OneBookingShouldHaveOnlyOneMainPassenger: "A booking can have only one main passenger.",
  OnlyRequesterCanCompleteCancellation: "Only the person who made the request can complete the cancellation.",
  OriginOrDestinationChangeNotAllowed: "The origin or destination cannot be changed.",
  PassengerBoardedAlready: "This passenger has already boarded.",
  PassengerCheckedInAlready: "This passenger is already checked in.",
  PassengerCityDoesNotExist: "The passenger's city does not exist.",
  PassengerCountryDoesNotExist: "The passenger's country does not exist.",
  PassengerDepartFromAnotherStation: "This passenger departs from another station.",
  PassengerDoesNotExist: "This passenger does not exist.",
  PassengerIdentityTypeIsInvalid: "The passenger's identity document type is invalid.",
  PassengerIsNotCheckedInYet: "This passenger is not checked in yet.",
  PassengerIsRequiredForModification: "A passenger is required for the change.",
  PassengerProfileChanged: "This entry would change the selected passenger profile. Please confirm the changes.",
  PassengerRegionDoesNotExist: "The passenger's region does not exist.",
  PassengerSearchLimitReached: "You have reached your passenger search limit. Please try again later.",
  PassengerSearchUnavailable: "Passenger search by phone number is unavailable.",
  PassengerTariffParameterIsRequired: "The passenger fare parameter is required.",
  PassengerWithNameIsDuplicated: "A passenger with this name is entered more than once.",
  PayModeIsInvalid: "The payment mode is invalid.",
  PaymentMethodIsRequired: "The payment method is required.",
  PdfTemplateDoesNotExist: "This PDF template does not exist.",
  PdfTemplateIsAlreadyExist: "This PDF template already exists.",
  PermissionDenied: "You do not have permission to perform this action.",
  PhoneCodeIsRequired: "The phone country code is required.",
  PhoneCodeIsRequiredForMainPassenger: "The phone country code is required for the main passenger.",
  PhoneNumberIsRequired: "The phone number is required.",
  PhoneNumberIsRequiredForMainPassenger: "The phone number is required for the main passenger.",
  PhoneNumberIsRequiredForSendTicketReceiptBySms: "A phone number is required to send the receipt by SMS.",
  PinCodeIsBlocked: "The PIN code is blocked.",
  PinCodeIsExpired: "The PIN code has expired.",
  PinCodeIsNotCorrect: "The PIN code is incorrect.",
  PinCodeIsRequired: "The PIN code is required.",
  PlanAlreadyActive: "This plan is already active.",
  PlanNotAllowToSubscribe: "You cannot subscribe to this plan.",
  PleaseSelectAConflictTripToCancel: "Please select a trip in conflict to cancel.",
  PreDepartureTripIsRequired: "The outbound trip is required.",
  PrePassengersAreRequired: "Passengers are required.",
  PreReturnTripIsRequired: "The return trip is required.",
  PreSeatIsMissingForSomePassengers: "A seat is missing for some passengers.",
  PreSourceIdAndDestinationIdAreRequired: "The departure and destination stations are required.",
  ProcessClaimActionInvalid: "The claim action is invalid.",
  ProcessClaimDescriptionIsRequired: "The claim description is required.",
  PromoCodeIsInvalidOrExpired: "This promo code is invalid or has expired.",
  PromotionCodeAlreadyExist: "This promo code already exists.",
  ReceiverFirstNameIsRequired: "The recipient's first name is required.",
  ReceiverLastNameIsRequired: "The recipient's last name is required.",
  ReceiverPhoneCodeIsRequired: "The recipient's phone country code is required.",
  ReceiverPhoneNumberIsRequired: "The recipient's phone number is required.",
  ReceiverTitleIsRequired: "The recipient's title is required.",
  ReconciliationAmountDifferenceInCorrect: "The reconciliation amount difference is incorrect.",
  RecordNotFoundWithSpecifiedId: "The requested record was not found.",
  RecordSavedButSendSmsToCashiersAreFailed: "The record was saved, but the SMS could not be sent to the cashiers.",
  RefreshTokenInvalid: "Your session is invalid. Please sign in again.",
  RefreshTokenUnSuccessful: "Your session could not be renewed. Please sign in again.",
  RefundAmountIncorrect: "The refund amount is incorrect.",
  RefundCouldNotBeANegativeNumber: "The refund amount cannot be negative.",
  RegionNameAlreadyExist: "This region name already exists.",
  RegisterCodeDuplicated: "This register code already exists.",
  RegisterDoesNotExist: "This register does not exist.",
  RegisterIdIsRequired: "The register is required.",
  RegisterIsClosed: "This register is closed.",
  RegisterIsNotOpenForCashier: "Your cash register is not open.",
  RegisterIsOpenedBySomeone: "This register is already opened by another user.",
  RegisterNewLianeUserSessionInvalidOrExpired: "The registration session is invalid or has expired.",
  RegisterNewLianeUserUnsuccessful: "The registration failed.",
  RegisterStatusIsNotValidForCreation: "This register status is not valid for creation.",
  RemoveBasicTariffUnsuccessful: "The base fare could not be removed.",
  RequestedBookingAlreadyExist: "This booking already exists.",
  RequestedPassengerDoesNotExistForCurrentBooking: "This passenger is not part of this booking.",
  ReserveSeatsFailed: "The seats could not be reserved.",
  ResetPasswordLinkIsInvalidOrExpired: "The password reset link is invalid or has expired.",
  ResetPasswordSuccessful: "Your password has been reset.",
  ResetPasswordUnSuccessful: "The password could not be reset.",
  ReturnSeatIsRequired: "The return seat is required.",
  ReturnTicketConditionIsRequiredForModification: "The return ticket condition is required for the change.",
  ReturnTripAndSeatAreSameAsCurrentTrip: "The return trip and seat are the same as the current ones.",
  ReturnTripCompanyIdIsRequired: "The return trip company is required.",
  ReturnTripDoesNotExist: "The return trip does not exist.",
  ReturnTripStatusIsNotValidToModify: "The return trip status does not allow changes.",
  RoleAlreadyExist: "This role already exists.",
  RoleCustomizationRequiresCompany: "A company is required to customize roles.",
  RoleIsUsingForSomeUsers: "This role is assigned to some users and cannot be removed.",
  RolesAreDefinedBySystem: "Roles are defined by the system.",
  RouteAlreadyExist: "This route already exists.",
  RouteDoesNotExist: "This route does not exist.",
  RouteIsUsingForSomeTrips: "This route is used by some trips.",
  SignedTicketRequired: "Sale refused: ticket signed by the terminal is missing.",
  SOTGDistanceMustBeAPositiveNumber: "The distance must be a positive number.",
  SOTGPassengerTicketAmountIsInvalid: "The passenger's ticket amount is invalid.",
  SOTGTariffNotFound: "No fare for this journey and class.",
  SOTGTicketAmountMismatch: "The amount does not match the fare.",
  SOTGTicketAmountMustBeAPositiveNumber: "The ticket amount must be a positive number.",
  SeatNoLongerAvailable: "This seat is no longer available.",
  SeatingModelAlreadyUsedForSomeBookings: "This seating layout is already used by some bookings.",
  SeatingModelDoesNotExist: "This seating layout does not exist.",
  SeatingModelHasNoAvailableSeat: "This seating layout has no available seats.",
  SeatsAreTakenBySellOnTheGoBooking: "Some seats are already taken by an onboard sale.",
  SegmentAlreadyExist: "This segment already exists.",
  SegmentAlreadyUsedForSomeTrips: "This segment is used by some trips.",
  SegmentBaseRateEqualsZero: "The base fare for this segment is zero.",
  SegmentIsUsingForSomeUncompletedBookings: "This segment is used by some bookings that are not completed.",
  SelectedBookingDoseNotExist: "The selected booking does not exist.",
  SelectedBoxCategoryDoesNotExist: "The selected parcel category does not exist.",
  SelectedBoxVolumeDoesNotExist: "The selected volume does not exist.",
  SelectedBoxWeightDoesNotExist: "The selected weight range does not exist.",
  SelectedCityDoesNotExist: "The selected city does not exist.",
  SelectedDepartureSeatIdIsRequired: "The outbound seat is required.",
  SelectedDepartureTripIdIsRequired: "The outbound trip is required.",
  SelectedExistingPassengerDoesNotExist: "The selected passenger does not exist.",
  SelectedReceiverDoesNotExist: "The selected recipient does not exist.",
  SelectedReturnSeatIdIsRequired: "The return seat is required.",
  SelectedReturnTripIdIsRequired: "The return trip is required.",
  SelectedSeatDoesNotExist: "The selected seat does not exist.",
  SelectedSeatIdIsRequired: "The seat is required.",
  SelectedSenderDoesNotExist: "The selected sender does not exist.",
  SelectedShipmentsHaveDifferentRoute: "The selected shipments have different routes.",
  SelectedTariffParametersDoNotExist: "The selected fare parameters do not exist.",
  SelectedTicketClassDoesNotExist: "The selected ticket class does not exist.",
  SelectedTicketTariffDoesNotExist: "The selected fare does not exist.",
  SelectedTripDoesNotExist: "The selected trip does not exist.",
  SelectedTripIdIsRequired: "The trip is required.",
  SendTicketSmsMessageFailed: "The ticket SMS could not be sent.",
  SenderFirstNameIsRequired: "The sender's first name is required.",
  SenderLastNameIsRequired: "The sender's last name is required.",
  SenderPhoneCodeIsRequired: "The sender's phone country code is required.",
  SenderTitleIsRequired: "The sender's title is required.",
  ServerInternalException: "An unexpected server error occurred. Please try again.",
  ShipmentBoxAlreadyLoaded: "This parcel has already been loaded.",
  ShipmentBoxAlreadyOffloaded: "This parcel has already been unloaded.",
  ShipmentBoxDepartFromAnotherStation: "This parcel departs from another station.",
  ShipmentBoxDestinationIsNotMatched: "This parcel's destination does not match.",
  ShipmentBoxDoesNotExist: "This parcel does not exist.",
  ShipmentBoxIdIsRequired: "The parcel is required.",
  ShipmentBoxListIsRequired: "At least one parcel is required.",
  ShipmentBoxStatusIsNotAllowToCancel: "This parcel cannot be cancelled in its current status.",
  ShipmentBoxStatusIsNotAllowToLaunchClaim: "A claim cannot be opened for this parcel in its current status.",
  ShipmentClaimAlreadyExist: "A claim already exists for this shipment.",
  ShipmentDestinationStationIsRequired: "The destination station is required.",
  ShipmentDoesNotExist: "This shipment does not exist.",
  ShipmentHasNoBoxInClaim: "This shipment has no parcel under claim.",
  ShipmentIdIsRequired: "The shipment is required.",
  ShipmentInsuranceIsNotConfiguredYet: "Parcel insurance is not configured yet.",
  ShipmentNotificationTariffAmountIsInvalid: "The notification fee amount is invalid.",
  ShipmentNotificationTariffConfigurationNotFound: "The notification fee is not configured.",
  ShipmentNotificationTariffIsChanged: "The notification fee has changed. Please check the new amount.",
  ShipmentNotificationTariffToReceiverIsNotEnabled: "Notification to the recipient is not enabled.",
  ShipmentNotificationTariffToSenderIsNotEnabled: "Notification to the sender is not enabled.",
  ShipmentReceiverIsRequired: "The recipient is required.",
  ShipmentSenderIsRequired: "The sender is required.",
  ShipmentSourceOrDestinationDoesNotExist: "The departure or destination station does not exist.",
  ShipmentSourceStationIsRequired: "The departure station is required.",
  ShipmentStatusIsNotAllowToCancel: "This shipment cannot be cancelled in its current status.",
  ShipmentStatusIsNotAllowToLaunchClaim: "A claim cannot be opened for this shipment in its current status.",
  ShipmentStatusIsNotAllowToProcessClaim: "The claim cannot be processed for this shipment in its current status.",
  ShipmentTariffIdIsRequired: "The parcel fare is required.",
  ShipmentTariffIsAlreadyExist: "This parcel fare already exists.",
  ShipmentTariffIsInvalid: "The parcel fare is invalid.",
  SignedTicketExpired: "This ticket QR code has expired.",
  SignedTicketForAnotherTrip: "This ticket is for another trip.",
  SignedTicketInvalid: "This ticket QR code is invalid.",
  SignedTicketNotYetValid: "This ticket QR code is not valid yet.",
  SignedTicketOutdated: "This ticket has been modified since it was printed. Use the reprinted ticket.",
  SignedTicketUnknownKey: "This ticket QR code was signed with an unknown key.",
  SmsTemplateDoseNotExist: "This SMS template does not exist.",
  SmsTemplateIsAlreadyExist: "This SMS template already exists.",
  SomeCashiersDoesNotExists: "Some cashiers do not exist.",
  SomeDepartureSeatsAreTakenBySellOnTheGoBooking: "Some outbound seats are already taken by an onboard sale.",
  SomeDepartureSeatsAreUnavailable: "Some outbound seats are unavailable.",
  SomePassengersAreMissing: "Some passengers are missing.",
  SomePassengersDoNotExistForThisBookingSession: "Some passengers do not belong to this booking session.",
  SomeRequestedTicketsForCancellationDoesNotExist: "Some of the tickets to cancel do not exist.",
  SomeRequestedTripDoseNotExist: "Some requested trips do not exist.",
  SomeReturnSeatsAreTakenBySellOnTheGoBooking: "Some return seats are already taken by an onboard sale.",
  SomeReturnSeatsAreUnavailable: "Some return seats are unavailable.",
  SomeSeatsAreUnavailable: "Some seats are unavailable.",
  SomeSelectedShipmentBoxesDoNotExist: "Some selected parcels do not exist.",
  SomeSelectedShipmentsDoNotExist: "Some selected shipments do not exist.",
  SomeSelectedStationsDoNotExist: "Some selected stations do not exist.",
  SomeShipmentStatusIsNotAllowToDoTripAssignment: "Some shipments cannot be assigned to a trip in their current status.",
  SourceCityDoesNotHaveAnyStation: "The departure city has no station.",
  SourceIdIsRequired: "The departure station is required.",
  SourceNameIsRequired: "The departure station name is required.",
  SourceStationIsNotBelongToSelectedTrip: "The departure station is not on the selected trip.",
  StationBalanceProofInvalid: "The station balance receipt is invalid.",
  StationCityDoesNotExist: "The station's city does not exist.",
  StationCodeAlreadyExist: "This station code already exists.",
  StationDoesNotExist: "This station does not exist.",
  StationEmailAlreadyExist: "This station email address already exists.",
  StationNameAlreadyExist: "This station name already exists.",
  StationNotFound: "The station was not found.",
  StationPrinterAlreadyExist: "This printer already exists for the station.",
  SubscribePaymentDoseNotSuccess: "The subscription payment was not successful.",
  SupervisorNotAllowed: "This user is not allowed to approve this operation.",
  SupervisorPinBlocked: "The station chief PIN is blocked after too many attempts.",
  SupervisorPinInvalid: "The station chief PIN is incorrect.",
  SupervisorPinRequired: "The station chief PIN is required.",
  SyncBookingMissingSomeBookedTicketsFromRequest: "Some booked tickets are missing from the synchronization.",
  SyncBookingOfflineSeatIsBlockedOrAlreadyBooked: "A seat sold offline is blocked or already booked.",
  SyncCheckInAndBoardingTicketRefNoRequired: "The ticket number is required.",
  SyncCheckInAndBoardingTripIdIsRequired: "The trip is required.",
  SyncCheckInAndBoardingUpdatedOnIsRequired: "The update date is required.",
  SyncNoOfTicketsFromExistingBookingNotEqualsNoOfTicketsFromSyncRequest: "The number of tickets does not match the existing booking.",
  SyncTripEventCreatedOnIsRequired: "The trip event creation date is required.",
  SyncTripEventIdIsRequired: "The trip event is required.",
  SystemRoleIsReadOnly: "System roles cannot be modified.",
  TabletBookedSeatIsRequired: "The booked seat is required.",
  TabletBookingReturnArrivalDateTimeIsInvalid: "The return arrival date and time are invalid.",
  TabletBookingReturnDepartureDateTimeIsInvalid: "The return departure date and time are invalid.",
  TabletSeatKeyRequired: "The seat key is required.",
  TabletSeatNameRequired: "The seat name is required.",
  TabletSeatingModelIdIsRequired: "The seating layout is required.",
  TabletSeatingModelNameIsRequired: "The seating layout name is required.",
  TabletSeatingModelTypeIsInvalid: "The seating layout type is invalid.",
  TabletTicketClassIdIsRequired: "The ticket class is required.",
  TabletTicketClassNameIsRequired: "The ticket class name is required.",
  TabletTicketConditionNameIsRequired: "The ticket condition name is required.",
  TabletTicketPassengerInfoIsRequired: "The passenger information is required.",
  TabletTotalPaidIsNotEqualTotalTicketAmount: "The total paid does not match the total ticket amount.",
  TabletTripCodeIsRequired: "The trip code is required.",
  TabletTripDiscountAmountIsInvalid: "The trip discount amount is invalid.",
  TabletTripNetAmountIsInvalid: "The trip net amount is invalid.",
  TabletTripRouteTypeIsInvalid: "The trip route type is invalid.",
  TabletTripTicketAmountIsInvalid: "The trip ticket amount is invalid.",
  TariffAgeMismatchUseTicketModification: "This date of birth no longer matches the ticket fare. Make a ticket modification to change the fare.",
  TariffAgeOutOfRange: "The passenger's age on the departure date is outside the limits of this fare.",
  TariffBirthDateRequired: "A date of birth is required for this fare.",
  TariffParameterIdIsRequired: "The fare parameter is required.",
  TariffParameterNameIsRequired: "The fare parameter name is required.",
  TerminalEnrollmentCodeInvalid: "The device enrollment code is invalid.",
  TerminalEnrollmentTooManyAttempts: "Too many enrollment attempts. Please try again later.",
  TheBusHasPassedThroughSelectedDepartureStation: "The bus has already passed the selected departure station.",
  TheTicketHasNoTripValidToModify: "This ticket has no trip that can be modified.",
  TicketAlreadyPrinted: "This ticket has already been printed.",
  TicketCancelDeparted: "This ticket cannot be cancelled because the bus has already departed.",
  TicketCancelNotAllowedStatus: "This ticket cannot be cancelled in its current status.",
  TicketCancellationPolicySettingWithSameTicketConditionAlreadyExist: "A cancellation policy with this ticket condition already exists.",
  TicketClassIsUsedForSomeCompanies: "This ticket class is used by some companies.",
  TicketConditionIdIsRequired: "The ticket condition is required.",
  TicketHasNoConflictedTrip: "This ticket has no trip in conflict.",
  TicketIdAlreadyExist: "This ticket already exists.",
  TicketIdIsRequired: "The ticket is required.",
  TicketIsCancelledAlready: "This ticket is already cancelled.",
  TicketLookupCriteriaMissing: "Enter at least one search criterion.",
  TicketModificationComingSoon: "Ticket modification will be available soon.",
  TicketModificationDestinationNotServed: "This departure does not serve the new destination.",
  TicketModificationFeesWaivedNeedsSupervisor: "Waiving the fees requires station chief approval.",
  TicketModificationGroupNotSameBooking: "All tickets in the group must belong to the same booking.",
  TicketModificationGroupSameDeparture: "All tickets in the group must have the same new departure for each direction.",
  TicketModificationGroupSameDestination: "All tickets in the group must have the same destination for each direction.",
  TicketModificationGroupSameSeat: "Two passengers cannot have the same seat.",
  TicketModificationGroupTooLarge: "Too many tickets in the group. The maximum is 9.",
  TicketModificationHolderInvalid: "The ticket holder's name is required.",
  TicketModificationLianeNotSupported: "Tickets booked through Liane cannot be modified here.",
  TicketModificationLimitReached: "The maximum number of modifications for this ticket has been reached.",
  TicketModificationNotAllowedStatus: "This ticket cannot be modified in its current status.",
  TicketModificationNothingToChange: "There is nothing to change on this ticket.",
  TicketModificationPriceChanged: "The modification price has changed. Please check the new amount.",
  TicketModificationQuoteExpired: "This modification quote has expired. Please request a new one.",
  TicketModificationQuoteNotFound: "This modification quote was not found.",
  TicketModificationRefundModeInvalid: "The refund method is invalid.",
  TicketModificationRefundNeedsSupervisor: "A refund requires station chief approval.",
  TicketModificationSeatRequired: "The seat is required.",
  TicketModificationSettingWithSameTicketConditionAlreadyExist: "A ticket change setting with this ticket condition already exists.",
  TicketModificationTooLate: "It is too late to modify this ticket.",
  TicketModificationTransferNeedsSupervisor: "A transfer requires station chief approval.",
  TicketModified: "This ticket has been modified. Use the reprinted ticket.",
  TicketNotModifiable: "This ticket cannot be modified.",
  TicketPrintAttemptNotFound: "This print attempt was not found.",
  TicketPrintAttemptsExhausted: "The maximum number of print attempts for this ticket has been reached.",
  TicketPrintWindowClosed: "The time allowed to print this ticket has passed.",
  TicketReplaced: "This ticket has been replaced by a new ticket.",
  TicketReprintBoarded: "This ticket cannot be reprinted because the passenger has already boarded.",
  TicketReprintCancelled: "This ticket cannot be reprinted because it has been cancelled.",
  TicketReprintDeparted: "This ticket cannot be reprinted because the bus has already departed.",
  TicketReprintNotIssued: "This ticket cannot be reprinted because it has not been issued.",
  TicketSettingCompanyNameIsAlreadyExist: "This company display name is already used for this country.",
  TicketStatusIsNotAllowToCancel: "The ticket status does not allow cancellation.",
  TotalBaggageAmountIsInvalid: "The total baggage amount is invalid.",
  TotalBaggageMustLessThanMaxBagAllowed: "The total number of bags exceeds the maximum allowed.",
  TotalChangeAmountIsInvalid: "The total change amount is invalid.",
  TotalReconciliationAmountChanged: "The total reconciliation amount has changed. Please refresh and try again.",
  TotalShipmentAmountIsInvalid: "The total parcel amount is invalid.",
  TransportVendorIsAlreadyUsedForSomeBuses: "This transport vendor is linked to some buses.",
  TransportVendorNameOrEmailAlreadyExist: "A transport vendor with this name or email already exists.",
  TripAlreadyDeparted: "This trip has already departed from the boarding station.",
  TripAndSeatAreSameAsCurrentTrip: "The trip and seat are the same as the current ones.",
  TripBoardingClosed: "Boarding for this trip is closed.",
  TripDelayedTimeIsRequired: "The delay time is required.",
  TripDetailIdIsRequired: "The trip is required.",
  TripDirectionsAreRequired: "The trip directions are required.",
  TripDoesNotExist: "This trip does not exist.",
  TripEventDetailsIsRequired: "The trip event details are required.",
  TripExistButSomeTariffParametersIsNotConfigured: "Trips exist, but some fare parameters are not configured.",
  TripGroupNameAlreadyExist: "This trip group name already exists.",
  TripHasSomeRemainingStops: "This trip still has remaining stops.",
  TripIsAlreadyArrived: "This trip has already arrived.",
  TripIsNotAllowToUpdate: "This trip can no longer be modified.",
  TripIsNotAssignToAnyBusYet: "No bus has been assigned to this trip yet.",
  TripIsNotAssignToAnyDriverYet: "No driver has been assigned to this trip yet.",
  TripLocationMustHaveAtLeastStationIdOrLocationId: "Each trip location must have a station or a location.",
  TripLocationsAreRequired: "The trip locations are required.",
  TripNameAlreadyExist: "This trip name already exists.",
  TripStatusIsNotAllowToUpdateCurrentLocation: "The trip's current location cannot be updated in its current status.",
  TripStatusIsNotValidToModify: "The trip status does not allow changes.",
  TripStatusIsNotValidToSellTicketOnTheGo: "Tickets cannot be sold on board for this trip in its current status.",
  TripStatusRecordCurrentStationIdIsRequired: "The current station is required for the status record.",
  TripStatusRecordIdIsRequired: "The trip status record is required.",
  TripStatusRecordSomeTripsDoNotExist: "Some trips in the status records do not exist.",
  TripStatusRecordTripDetailIdIsRequired: "The trip is required for the status record.",
  TripStatusRecordUpdatedOnIsRequired: "The update date is required for the status record.",
  TripTariffDoesNotExist: "The fare for this trip does not exist.",
  TripTravelerReportPdfTemplateDoesNotExist: "The passenger list PDF template does not exist.",
  UnknownSortField: "The sort field is not recognized.",
  UpdateAvailableSeatForTripDetailFailed: "The available seats for this trip could not be updated.",
  UpdateBasicTariffUnsuccessful: "The base fare could not be updated.",
  UpdateLianeUserEmailAddressUnsuccessful: "The email address update failed.",
  UpdateLianeUserPhoneNumberUnsuccessful: "The phone number update failed.",
  UpdateTripDetailInfoUnsuccessful: "The trip details could not be updated.",
  UpdateUserAccountUnsuccessful: "The user account could not be updated.",
  UploadVideoFailed: "The video upload failed.",
  UseSignedSync: "This old synchronization is no longer accepted. Update the app.",
  UseTicketReprint: "This ticket has already been printed. Use reprint in the Tickets section.",
  UserCompanyDoesNotExist: "The user's company does not exist.",
  UserDoesNotExist: "This user does not exist.",
  UserEmailAlreadyExist: "This email address is already used by another user.",
  UserImageFormatInvalid: "The image format is invalid.",
  UserIsLockedOut: "This account is temporarily locked. Please try again later.",
  UserIsNotActive: "This user account is not active.",
  UserOldPasswordInvalid: "The current password is incorrect.",
  UserSecretKeyDoesNotExist: "The user secret key does not exist.",
  UserSecretKeyIsRequired: "The user secret key is required.",
  UserTypeIsNotAllowToChangePassword: "This type of user cannot change the password.",
  YouDontHavePermissionOnThisTrip: "You do not have permission for this trip.",
};

export default serverEnMessages;
